import { IconName } from '@ardoq/icons';
import { SettingsType, ToggleConfig } from '@ardoq/view-settings';
import { onViewSettingsUpdate } from './onViewSettingsUpdate';
import { t, type I18nLocale } from '@ardoq/i18n';

const includeAllDescendantsMenuItem = (
  isActive: boolean,
  i18nLocale: I18nLocale
): ToggleConfig => ({
  id: 'includeAllDescendants',
  label: t(
    i18nLocale,
    'tabview:shared.includeDescendants.label',
    'Include descendants'
  ),
  iconName: isActive ? IconName.BLUR_ON : IconName.BLUR_OFF,
  isActive,
  type: SettingsType.TOGGLE,
  onViewSettingsUpdate,
});
export { includeAllDescendantsMenuItem };
